import { render } from "./DataPrivacy.vue?vue&type=template&id=008bdd5b"
const script = {}

import exportComponent from "C:\\Projects\\Asistenca\\old-website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__